import { render } from "./fugaoyaoxue-news.vue?vue&type=template&id=0cc8542a&scoped=true"
import script from "./fugaoyaoxue-news.vue?vue&type=script&lang=js"
export * from "./fugaoyaoxue-news.vue?vue&type=script&lang=js"

import "./fugaoyaoxue-news.vue?vue&type=style&index=0&id=0cc8542a&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc8542a"]])

export default __exports__